import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export const FrameworkSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      data-testid="framework-section"
      ref={ref}
      className="py-16 md:py-24 lg:py-32 bg-[#F4F1EC] relative overflow-hidden"
    >
      <div className="container-peak">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-12 lg:mb-16"
        >
          <span className="section-tag block mb-4 lg:mb-6">Our Framework</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-light leading-[1.15] mb-4 lg:mb-6 text-[#1F2A44]">
            The <em className="not-italic text-[#D97904]">Peak Triad</em> Blueprint
          </h2>
          <p className="text-[#5A6B7A] text-sm lg:text-base px-4">
            A framework to achieve peak in any area of life — while ensuring no other area descends into disaster.
          </p>
        </motion.div>

        {/* Triangle Visualization */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="relative max-w-[250px] sm:max-w-[300px] lg:max-w-sm mx-auto"
        >
          <svg viewBox="0 0 300 260" className="w-full h-auto">
            {/* Triangle outline */}
            <polygon
              points="150,20 280,240 20,240"
              fill="none"
              stroke="#1F2A44"
              strokeWidth="1.5"
            />
            
            {/* Inner triangle */}
            <polygon
              points="150,50 250,210 50,210"
              fill="none"
              stroke="#D97904"
              strokeWidth="0.5"
              opacity="0.4"
            />

            {/* Connection lines */}
            <line x1="150" y1="20" x2="150" y2="135" stroke="#D97904" strokeWidth="0.5" opacity="0.4" />
            <line x1="280" y1="240" x2="150" y2="135" stroke="#D97904" strokeWidth="0.5" opacity="0.4" />
            <line x1="20" y1="240" x2="150" y2="135" stroke="#D97904" strokeWidth="0.5" opacity="0.4" />

            {/* Center dot */}
            <circle cx="150" cy="135" r="4" fill="#D97904" />

            {/* Corner circles */}
            <circle cx="150" cy="20" r="8" fill="#F4F1EC" stroke="#1F2A44" strokeWidth="1.5" />
            <circle cx="280" cy="240" r="8" fill="#F4F1EC" stroke="#1F2A44" strokeWidth="1.5" />
            <circle cx="20" cy="240" r="8" fill="#F4F1EC" stroke="#1F2A44" strokeWidth="1.5" />
          </svg>

          {/* Labels */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-5 lg:-translate-y-6 text-center">
            <span className="text-[#1F2A44] text-xs lg:text-sm font-['Syne'] tracking-[0.15em] uppercase font-semibold">Systems</span>
          </div>

          <div className="absolute bottom-0 right-0 translate-x-2 lg:translate-x-6 text-left">
            <span className="text-[#1F2A44] text-xs lg:text-sm font-['Syne'] tracking-[0.15em] uppercase font-semibold">Recovery</span>
          </div>

          <div className="absolute bottom-0 left-0 -translate-x-2 lg:-translate-x-6 text-right">
            <span className="text-[#1F2A44] text-xs lg:text-sm font-['Syne'] tracking-[0.15em] uppercase font-semibold">Balance</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FrameworkSection;
